var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8955 19.9986H8.76953L10.5227 10.0312H22.6486L20.8955 19.9986Z",
    fill: "#808486"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6717 7H10.7034L10.5215 8.03244H14.7684L14.6717 7Z",
    fill: "#808486"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8935 19.9986H8.76758L10.5207 10.0312H22.6466L20.8935 19.9986Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6717 7H10.7034L10.5215 8.03244H14.7684L14.6717 7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.2777 7.42129C10.2512 7.30713 10.2512 7.18838 10.2777 7.07422C10.3043 7.18838 10.3043 7.30713 10.2777 7.42129Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92352 7.52265C9.883 7.48053 9.84808 7.43333 9.81965 7.38223C9.78982 7.33219 9.76642 7.27857 9.75 7.22266C9.79064 7.26453 9.82557 7.31161 9.85388 7.36268C9.88364 7.4129 9.90703 7.46663 9.92352 7.52265Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66883 7.79072C9.55699 7.75664 9.45446 7.69727 9.36914 7.61719C9.42494 7.63344 9.47843 7.65677 9.52834 7.6866C9.57932 7.71529 9.62652 7.75027 9.66883 7.79072Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57867 8.14495C9.46478 8.17155 9.34631 8.17155 9.23242 8.14495C9.34631 8.11835 9.46478 8.11835 9.57867 8.14495Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6821 8.5C9.6399 8.54041 9.59284 8.57539 9.54201 8.60412C9.4921 8.63395 9.43861 8.65728 9.38281 8.67354C9.42483 8.63292 9.47192 8.59792 9.52291 8.56941C9.57274 8.53944 9.62625 8.5161 9.6821 8.5Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94656 8.75391C9.91268 8.86617 9.85344 8.9691 9.77344 9.0547C9.78964 8.9987 9.81306 8.94506 9.84309 8.89513C9.87146 8.84384 9.90623 8.79639 9.94656 8.75391Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3052 8.84375C10.319 8.90053 10.3257 8.95883 10.3251 9.01729C10.3259 9.07575 10.3192 9.13408 10.3052 9.19082C10.2909 9.13411 10.2842 9.07576 10.2853 9.01729C10.2846 8.95883 10.2913 8.90053 10.3052 8.84375Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6562 8.74299C10.6968 8.78511 10.7317 8.83231 10.7601 8.88341C10.79 8.93336 10.8133 8.987 10.8294 9.04298C10.7494 8.95739 10.6901 8.85446 10.6562 8.74219V8.74299Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9121 8.47656C10.968 8.49267 11.0215 8.516 11.0713 8.54598C11.1223 8.57448 11.1694 8.60948 11.2114 8.6501C11.1555 8.63399 11.102 8.61066 11.0522 8.58068C11.0012 8.55218 10.9541 8.51718 10.9121 8.47656Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.998 8.1176C11.1121 8.09101 11.2307 8.09101 11.3447 8.1176C11.2307 8.14419 11.1121 8.14419 10.998 8.1176Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8973 7.76338C10.9394 7.723 10.9865 7.68815 11.0374 7.65966C11.0871 7.62939 11.1406 7.60592 11.1966 7.58984C11.1112 7.67004 11.0085 7.72942 10.8965 7.76338H10.8973Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6328 7.51093C10.6492 7.45507 10.6725 7.40146 10.7021 7.35136C10.7305 7.30026 10.7654 7.25306 10.8059 7.21094C10.7899 7.26692 10.7666 7.32056 10.7367 7.37051C10.7083 7.42161 10.6733 7.46881 10.6328 7.51093Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8775 20H8.72568L7 10.3945H19.1522L20.8775 20Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2101 16.2664C11.4891 16.2664 11.7152 16.0397 11.7152 15.7602C11.7152 15.4806 11.4891 15.2539 11.2101 15.2539C10.9312 15.2539 10.7051 15.4806 10.7051 15.7602C10.7051 16.0397 10.9312 16.2664 11.2101 16.2664Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2043 16.2664C15.4832 16.2664 15.7093 16.0397 15.7093 15.7602C15.7093 15.4806 15.4832 15.2539 15.2043 15.2539C14.9253 15.2539 14.6992 15.4806 14.6992 15.7602C14.6992 16.0397 14.9253 16.2664 15.2043 16.2664Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9333 16.3485L13.9054 16.2955C13.9031 16.2907 13.642 15.8072 13.117 15.8072C12.6394 15.8072 12.52 16.2624 12.5169 16.2819L12.5025 16.3398L12.3867 16.3118L12.4006 16.2536C12.4006 16.248 12.5431 15.6875 13.117 15.6875C13.714 15.6875 13.9994 16.2173 14.0113 16.24L14.0392 16.2927L13.9333 16.3485Z",
    fill: "#263238"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFound);
export default __webpack_public_path__ + "static/media/no-data-found.f33a4c34d9bac105f97355e1df50be30.svg";
export { ForwardRef as ReactComponent };